import { render, staticRenderFns } from "./GroupEditForm.vue?vue&type=template&id=a9f408d0"
import script from "./GroupEditForm.vue?vue&type=script&lang=js"
export * from "./GroupEditForm.vue?vue&type=script&lang=js"
import style0 from "./GroupEditForm.vue?vue&type=style&index=0&id=a9f408d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports